import { vars } from "plos/src/styles/theme.css";
import { style } from "@vanilla-extract/css";

export const sheetWrapper = style({
  padding: vars.space.m,
});
